import React, { useState,useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import { Avatar, Spin } from "antd";
import Styles from "../SearchPage/SearchpageStyles.module.css";
import QuestionBox from "./QuestionBox";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import {Empty} from "antd";

export default function TabsSaved({ onStateChange }) {
	const recommedState = useSelector((state)=>state.recommend)
	const pageState = useSelector((state) => state.favouriteQuestions);
	const sharedByMeState = useSelector((state) => state.sharedBy);
	const sharedWithMeState = useSelector((state) => state.sharedWith)
	const [isTabChanged, setIsTabChanged] = React.useState(false)
	const dispatch = useDispatch()
	const {updateFavouriteSearchedQuery,updateSharedBySearchedQuery,updateSharedWithSearchedQuery} = bindActionCreators(Actions,dispatch)
	const onClickRegen = (val) => {
		setVal(val);
		onStateChange(val)
	}
	

	const [val, setVal] = useState(recommedState.tabValue !== undefined && recommedState.tabValue !== null ? recommedState.tabValue : 1);

	const noDataAvailable = (pageState, sharedByMeState, sharedWithMeState) => {
		return (
			<div className="trendingfilterbar" style={{ textAlign: "center" }}>
				{(pageState.isLoading === false && pageState.data.length === 0 && val === 1) && (
					<>
					<Empty />
					</>
				)}
				{(sharedByMeState.isLoading === false && sharedByMeState.data.length === 0 && val === 2) && (
					<>
					<Empty />
					</>
				)}
				{(sharedWithMeState.isLoading === false && sharedWithMeState.data.length === 0 && val === 3) && (
					<>
					<Empty />
					</>
				)}
			</div>
		);
	};

	return (
		<>
			<div className="mt-4 mb-5">
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						marginBottom: "20px",
						gap: '12px'
					}}
				>
					<div
						className={val === 1 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(1)}
						style={{ cursor: 'pointer' }}
					>
						Favorites&nbsp;<Avatar className={Styles.numberAvatar} >{pageState.isLoading ? '0' : pageState.totalCount}</Avatar>
					</div>
					<div
						className={val === 2 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(2)}
						style={{ cursor: 'pointer' }}
					>
						Shared By Me&nbsp;<Avatar className={Styles.numberAvatar} >{sharedByMeState.isLoading ? '0' : sharedByMeState.totalCount}</Avatar>
					</div>
					<div
						className={val === 3 ? Styles.onSelectedtab : Styles.ohHovertab}
						onClick={() => onClickRegen(3)}
						style={{ cursor: 'pointer' }}
					>
						Shared With Me&nbsp;<Avatar className={Styles.numberAvatar} >{sharedWithMeState.isLoading ? '0' : sharedWithMeState.totalCount}</Avatar>
					</div>
				</div>
				{val === 1 && pageState.isLoading === false && pageState.data.length > 0 && pageState.data.map((obj, ind) => {
					return <QuestionBox data={obj} key={ind} tab={val} />
				})}
				{/* {val === 1 && pageState.isLoading === false && <FavouriteTabbedComponent data={pageState.data} tab={val} />} */}
				{
					val === 2 && sharedByMeState.isLoading === false && sharedByMeState.data.length > 0 && sharedByMeState.data.map((obj, ind) => {
						return <QuestionBox data={obj} key={ind} tab={val} />
					})
				}
				{
					val === 3 && sharedWithMeState.isLoading === false && sharedWithMeState.data.length > 0 && sharedWithMeState.data.map((obj, ind) => {
						return <QuestionBox data={obj} key={ind} tab={val} />
					})
				}
				{(pageState.isLoading && val === 1) && (
					<>
						<Spin spinning={true} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
					</>
				)}
				{
					(sharedByMeState.isLoading && val ===2) && (
						<>
							<Spin spinning={true} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
						</>
					)
				}
				{
					(sharedWithMeState.isLoading && val === 3) && (
						<>
							<Spin spinning={true} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
						</>
					)
				}
				{noDataAvailable(pageState, sharedByMeState, sharedWithMeState)}
			</div>
		</>
	);
}